import React from "react";
import { Container, Line, Main } from "../Styles/Global.Styled";
import PageHeader from "../Components/PageBanner/PageHeader";
import { css } from "styled-components";
import ContactForm from "../Forms/ContactForm/ContactForm";
import ContactSection from "../Components/Contacts/ContactSection";

const cntStyle = css`
  justify-content: center;
  align-items:center;
  padding: 5vh 10vw 10vh;
  gap: 5vh;
`;
const cntStyleMb = css`
  flex-direction: column;
  padding: 5vh 5vw;
`;
const lineStyle = css`
  height: 75vh;
  width: 0;
`;
const lineStyleMb = css`
  width: 100%;
  height: 0;
`;

const ContactUs = () => {
  return (
    <Main>
      <PageHeader header={"Contact us"} />
      <Container $baseStyle={cntStyle} $mStyle={cntStyleMb}>
        <ContactSection />
        <Line $baseStyle={lineStyle} $tStyle={lineStyleMb} />
        <ContactForm />
      </Container>
    </Main>
  );
};

export default ContactUs;
